<template>
    <div class="banner">
        <div ref="container" class="model-view"></div>
        <swiper :modules="modules" @swiper="initSwiper" :slidesPerView="1" @slideChange="onSlideChange" navigation
            :autoplay="autoplayConfig" :pagination="{ clickable: true }" :scrollbar="{ draggable: true }"
            class="swiper">
            <swiper-slide v-for="item in bannerList" :key="item">
                <div class="banner-content">
                    <div :style="{ backgroundImage: 'url(' + item.carouselImg + ')', transform: transform }"
                        class="background"></div>
                    <div class="content">
                        <h2>{{ item.title }}</h2>
                        <div v-html="item.sketch"></div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>
<script setup>
import { onMounted, computed, ref, watch, reactive } from 'vue'
import { useRouter } from 'vue-router'
import * as api from '@/request/front'
import { useStore } from 'vuex'
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
// import 'swiper/scss/autoplay';
import { Autoplay, Pagination, Navigation, Scrollbar, A11y, } from 'swiper/modules';
import { WEBSITE } from '@/request/http.js';
import axios from 'axios'

const modules = [Autoplay]
const bannerList = ref([])
const container = ref(null)
var viewer
function initViewer() {
    viewer = new SDK.Viewer(container.value)
    viewer.sceneManager.setBackground(null)
    viewer.canvas.style.background = 'transparent'
    viewer.sceneManager.setEnvMap(viewer.sceneManager.roomEnvironment)
    viewer.sceneManager.setEnvMapIntensity(1)
    viewer.sceneManager.ambientLight.intensity = 1
    viewer.addEventListener('update', viewer.controls.update)
    viewer.controls.enableZoom = false
    viewer.controls.enablePan = false
    viewer.controls.enableDamping = true
    // registerMouseEvent()
}

const cache = {}
var currentUrl
function loadModel(url) {
    if (!url) return
    if (cache[url]) {
        setTimeout(() => _load(cache[url]), 500)
        return
    }
    cache[url] = viewer.sceneManager.loader.loadModel(url, {
        parent: false
    })
    _load(cache[url])
    return cache[url]
    function _load(task) {
        task.then(m => {
            if (currentUrl == url) {
                viewer.controls.stopRotateAround()
                viewer.root.clear()
                viewer.root.add(m)
                viewer.fitCamera(m)
                viewer.controls.rotateAround(30 * 1000)
            }
            return m
        })
    }
}

function fetchList() {
    axios.post('https://admin.dfshuke.com/prod-api/pc/banner/getBannerList', {
        "columnId": 154,
        "limit": 99999,
        "page": 1,
        "websiteId": 10000002
    }).then(res => {
        bannerList.value = res.data.rows
        onSlideChange({ activeIndex: 0 }).then(() => {
            //预加载
            for (let i = 1; i < bannerList.value.length; i++) {
                // console.log('预加载模型:', bannerList.value[i].model)
                loadModel(bannerList.value[i].embedded)
            }
        })
    })
}

onMounted(() => {
    initViewer()
    fetchList()
})

const autoplayConfig = reactive({
    enabled: false,
    pauseOnMouseEnter: true,
    delay: 3000
})
const onSlideChange = e => {
    viewer.root.clear()
    currentUrl = bannerList.value[e.activeIndex].embedded
    return loadModel(bannerList.value[e.activeIndex].embedded)
}


var swiperInstance
const initSwiper = e => swiperInstance = e
const resume = () => swiperInstance.autoplay.resume()
const pause = () => swiperInstance.autoplay.pause()

</script>

<style scoped lang="scss">
.banner {
    width: 100%;
    height: 200rem;
    position: relative;

    :deep(.el-carousel__indicators) {
        bottom: 100rem;

        .el-carousel__button {
            background-color: #ccc;
        }
    }

    .model-view {
        width: 200rem;
        height: 200rem;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 2;
        cursor: pointer;
    }

    .swiper {
        width: 100%;
        height: 100%;
    }

    .banner-content {
        user-select: none;
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        cursor: pointer;

        .content {
            padding: 40rem 0 0 20rem;
            position: relative;
            z-index: 2;
            pointer-events: none;

            h2 {
                color: #121212;
                font-size: 14rem;
                width: 200rem;
            }

            :deep(p) {
                color: #383838;
                width: 200rem;
                font-size: 9rem;
                line-height: 18rem;
                margin-top: 20rem;
            }

        }

        .background {
            width: 100%;
            height: 100%;
            background-size: 100% 100%;
            position: absolute;
            z-index: 1;
            transform: scale(1.1);
        }
    }
}
</style>
